export function basicTask() {
	const backTop = document.querySelector(".back-to-top");
	const counterItem = document.querySelectorAll(".counter-up");
	const setBackground = document.querySelectorAll("[setBackground]");
	const menuToggle = document.querySelector(".site-menu-toggle");
	const closeMenu = document.querySelector(".close-menu");
	const searchToggle = document.querySelector(".search-toggle");
	const closeSearchToggle = document.querySelector(".close-search");
	const bodyWrap = document.querySelector("body");
	const menuMobile = document.querySelector(".mobile-nav-wrap");
	const searchWrap = document.querySelector(".search-overlay");
	const hamburger = document.querySelector(".hamburger");

	//Basic Toggle Function
	menuToggle.addEventListener("click", (e) => {
		e.preventDefault();
		menuMobile.classList.toggle("is-open");
		hamburger.classList.toggle("is-active");
		bodyWrap.classList.toggle("overlay-bg");
	});
	closeMenu.addEventListener("click", () => {
		menuMobile.classList.remove("is-open");
		hamburger.classList.remove("is-active");
		bodyWrap.classList.remove("overlay-bg");
	});

	// Search Toggle
	searchToggle.addEventListener("click", () => {
		searchWrap.classList.toggle("is-open");
		bodyWrap.classList.toggle("overlay-bg");
	});
	// Search Toggle
	closeSearchToggle.addEventListener("click", () => {
		searchWrap.classList.remove("is-open");
		bodyWrap.classList.toggle("overlay-bg");
	});

	//back to top
	backTop.addEventListener("click", (event) => {
		event.preventDefault();
		$("html, body").animate({ scrollTop: 0 }, "300");
	});
	//Side Nav Toggle
	//Toggle Nav
	$(".drop-menu .title em").on("click", function () {
		if ($(this).parents(".drop-menu").hasClass("active")) {
			$(".drop-menu .nav-menu").slideUp();
			$(".drop-menu").removeClass("active");
		} else {
			$(".drop-menu .nav-menu").slideUp();
			$(".drop-menu").removeClass("active");
			$(this).parent().next().slideDown();
			$(this).parents(".drop-menu").addClass("active");
		}
	});
	$(".toggle-nav .title-nav").on("click", function () {
		$(".side-nav").slideToggle();
	});
	$('.read-more-wrap').each(function (index) {
		$(this).addClass('read-instance-' + index);
		let $this = $('.read-instance-' + index);
		$this.each(function () {
			let height = $this.find('.article').outerHeight();
			if (height < 130) {
				$this.find('.btn-read-more').addClass('hide');
			} else {
				$this.find('.article').css({
					height: '130',
				});
			}
			let button = $this.find('.btn-read-more');
			let content = $this;
			button.on('click', function () {
				content.toggleClass('active');
			});
		});
	});
	//Toggle item
	$(".toggle-wrap").each(function (index, element) {
		let $this = $(this);
		$this.addClass("toggle-instance-" + index);
		$(".toggle-instance-" + index + " .toggle-item").click(function () {
			if ($(this).hasClass("is-toggle")) {
				$(this).find(".article").slideUp();
				$(this).removeClass("is-toggle");
			} else {
				$(this).find(".article").slideDown();
				$(this).addClass("is-toggle");
			}
		});
	});
	if ($(".sticky-nav").length) {
		$(".sticky-nav").scrollToFixed({
			zIndex: 99,
			marginTop: 80,
		});
	}

	$(window)
		.scroll(function () {
			var scrollDistance = $(window).scrollTop();
			// Assign active class to nav links while scolling
			$(".scroll-section-wrap .anchor-section-id").each(function (i) {
				if (
					$(this).position().top -
					$(".sticky-nav").outerHeight() -
					80 -
					1 <=
					scrollDistance
				) {
					$(".sticky-nav li.active").removeClass("active");
					$(".sticky-nav li").eq(i).addClass("active");
				}
			});
		})
		.scroll();
	$(".sticky-nav  a").on("click", function (event) {
		if (this.hash !== "") {
			let offset =
				$("header").outerHeight() + $(".sticky-nav").outerHeight();
			var hash = this.hash;
			$("html, body").animate(
				{
					scrollTop: $(hash).offset().top - offset,
				},
				800,
				function () {
					// window.location.hash = hash;
				}
			);
		} // End if
	});



	try {

		//About core value

		$(".about-value  .cover-block").on("click", function (event) {
			$('.about-value').addClass('is-active');
		});

		//About SVG

		$(".dealer-svg .path-g").on("mouseenter", function () {
			let element = $(this).attr("data-id");
			$(".dealer-svg .path-g").removeClass("active");
			$(this).addClass("active");
			$(".dealer-list .item").removeClass("is-active");
			$("." + element).addClass("is-active");
		});




	} catch (error) {

	}

	//Tab function
	$(".tab-nav a").on("click", function () {
		$(this).parents(".tab-nav").find("li").removeClass("active");
		$(this).parents("li").addClass("active");

		var tab = $(this).attr("data-type");
		$(this).parents("section").find(".tab-item").removeClass("active");
		$(this)
			.parents("section")
			.find("#" + tab)
			.addClass("active");
	});

	$(".toggle-wrap").each(function (index, element) {
		let $this = $(this);
		$this.addClass("toggle-instance-" + index);
		$(".toggle-instance-" + index + " .toggle-item").click(function () {
			if ($(this).hasClass("is-toggle")) {
				$(this).find(".article").slideUp();
				$(this).removeClass("is-toggle");
			} else {
				$(this).find(".article").slideDown();
				$(this).addClass("is-toggle");
			}
		});
	});

	$(".menu-item-has-children > a").wrap("<div class='title'></div>");
	$(".menu-item-has-children .title").append("<div class='icon'></div>");
	if ($(window).width() < 1200.1) {
		//Side Nav Toggle
		$(".side-nav-mobile .title-nav").on("click", function () {
			$(".side-nav").slideToggle();
		});
		$(".menu-item-has-children .title .icon").on("click", function () {
			if ($(this).parents(".menu-item-has-children").hasClass("active")) {
				$(".menu-item-has-children .sub-menu").slideUp();
				$(".menu-item-has-children").removeClass("active");
			} else {
				$(".menu-item-has-children .sub-menu").slideUp();
				$(".menu-item-has-children").removeClass("active");
				$(this).parent().next().slideDown();
				$(this).parents(".menu-item-has-children").addClass("active");
			}
		});

	}

	try {
		if ($(".product-detail .fullcontent table").length) {
			$(".product-detail .fullcontent table").wrap(
				"<div class='table-res'></div>"
			);
		}
	} catch (error) {

	}

	//Toggle item

	//setBackground
	setBackground.forEach((attributes) => {
		attributes.style.cssText = `
		background-image: url(${attributes.getAttribute("setBackground")});
		background-size: cover;
		background-position: center;
	  `;
	});
	if (counterItem !== null) {
		if (counterItem.length) {
			const counterUp = window.counterUp.default;
			const callback = (entries) => {
				entries.forEach((entry) => {
					const el = entry.target;
					if (
						entry.isIntersecting &&
						!el.classList.contains("is-visible")
					) {
						counterUp(el, {
							duration: 2000,
							delay: 120,
						});
						el.classList.add("is-visible");
					}
				});
			};
			const IO = new IntersectionObserver(callback, { threshold: 1 });

			counterItem.forEach((counter) => {
				IO.observe(counter);
			});
		}
	}
}
